import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  provideRouter,
  TitleStrategy,
  withComponentInputBinding,
} from '@angular/router';
import { routes } from './app.routes';
import { ReportingInterceptor } from './reporting/interceptors/reporting.interceptor';
import { FdsModule } from './.design-systems/fds/fds.module';
import { HighchartsConfig } from './reporting/modules/common/highcharts/highcharts-config';
import { CustomTitleService } from './services/custom-title/custom-title.service';

HighchartsConfig.applyHighchartsConfig();

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withComponentInputBinding()),
    { provide: HTTP_INTERCEPTORS, useClass: ReportingInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
    provideZoneChangeDetection(),
    FdsModule,
    provideAnimations(),
    { provide: TitleStrategy, useClass: CustomTitleService },
  ],
};
